module.exports = __webpack_public_path__ + "static/media/home11.2d500840.jpg";